import CONSTANTS from '../../constants';

export function membership(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.MEMBER.GET.MEMBERSHIP:
            return action.membership;
        default:
            return state
    }
}